import React from "react";
import "../../css/sharedStyles.css";
import "./landingPage.css";
import "../sectionTitle/sectionTitle.css";
import SectionTitle from "../sectionTitle/SectionTitle.js";

import { BrowserRouter, Route, browserHistory, Switch, Link, Router} from "react-router-dom";
import { createBrowserHistory } from 'history';
import { withRouter } from 'react-router-dom';

var LandingPage = class LandingPageLayout extends React.Component{
    
    componentDidMount(){
        this.props.changeCurrentPage("home")
      }//end componentDidMount() 


    render() {
      const inlineStyle = {
        marginBottom:"10px"
      }

      const routeBase = localStorage.getItem("routeBase"); 

      return (
        
        <div>

            <div className = "landingPageContainer">
            
                <div className ="landingPageOptionWrapper" id="curentlyTracking">
                    <Link to={routeBase + "/character"}>
                        <div className="landingPageOption">
                        <img src={this.props.characterInfo.headShot}  className="imageBorder" />
                        <SectionTitle title={"Currently Tracking"} margin = {"4px 0 0 0"}/>
                        </div>
                    </Link>
                </div>
            

                <div className ="landingPageOptionWrapper" id="videoDatabase">
                    <Link to={routeBase + "/videosPage"}>
                    <div className="landingPageOption">
                    <img src="http://www.webnamehere.com/jarvis/images/thorVideo.jpg" className="imageBorder" />
                    <SectionTitle title={"Video Database"} margin = {"4px 0 0 0"}/>
                    </div>
                    </Link>
                </div>
          

                <div className ="landingPageOptionWrapper" id="characterDatabase">
                    <Link to={routeBase + "/characterDatabase/page" + this.props.pagination.currentPage}>
                        <div className="landingPageOption">
                        <img src="http://i.annihil.us/u/prod/marvel/i/mg/3/50/537ba56d31087.jpg" className="imageBorder" />
                        <SectionTitle title={"Character Database"} margin = {"4px 0 0 0"}/>
                        </div>
                    </Link>
                </div>


                <div className ="landingPageOptionWrapper" id="comicDatabase">
                    <Link to={routeBase + "/comicDatabase/page" + this.props.pagination.currentPage}>
                        <div className="landingPageOption">
                        <img src="http://www.webnamehere.com/jarvis/images/jarvis_avengers_cover.jpg" className="imageBorder" />
                        <SectionTitle title={"Comic Database"} margin = {"4px 0 0 0"}/>
                        </div>
                    </Link>
                </div>


            </div>{/* end left side container */}






        </div>
      );
    }
  }

  export default withRouter(LandingPage);


// WEBPACK FOOTER //
// ./src/components/landingPage/landingPage.js